import FilterBy from "./FilterBy";
import { useRouter } from "next/router";

function Side({
  // searchCategories,
  // suggestWords,
  // onSearch,
  filterBy,
  onFilter,
  selectedFilterKeys,
}) {
  const { locale } = useRouter();
  return (
    <div className="col-span-3 p-3 border md:max-h-[70svh] top-[calc(10rem+var(--header-banner-height,0px))] overflow-y-auto red-scrollbar bg-white rounded-md max-[768px]:hidden sticky">
      {filterBy?.length ? (
        <div className="mb-4 border rounded-md">
          <h4 className="px-2 py-1 text-lg font-semibold border-b text-red">
            {locale === "ar" ? "التصفية" : "Filters"}
          </h4>
          <div className="flex flex-col px-3">
            <FilterBy
              {...{
                filterBy,
                onFilter,
                selectedFilterKeys,
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Side;
